import { CellActions } from 'vendor/pages/Private/@v2/Orders/components/cell/cell_actions'
import { CellOrderNumber } from 'vendor/pages/Private/@v2/Orders/components/cell/cell_order_number'

export const Cell = {
  Actions: CellActions,
  OrderNumber: CellOrderNumber,
}
